//
// IMPORTANT: This file is a schema and must be managed with extreme care.
// See types/schema/README.md for more information.
//

import type { AccountsTableColumnId } from '@/types/enums/accounts'

export const ACCOUNT_OVERVIEW_SCHEMA_VERSION = '1.0'

export interface ColumnState {
  colId: AccountsTableColumnId
  displayName: string
  visible: boolean
}

export enum AccountListConfigKeys {
  FilterPaneState = 'filterPaneState',
  RowClickBehavior = 'rowClickBehavior',
  QuickPreviewLocation = 'quickPreviewLocation',
  ViewType = 'viewType',
  ColumnState = 'columnState',
}

export interface AccountListConfig {
  [AccountListConfigKeys.FilterPaneState]: FilterPaneState
  [AccountListConfigKeys.RowClickBehavior]: RowClickBehavior
  [AccountListConfigKeys.QuickPreviewLocation]: QuickPreviewLocation
  [AccountListConfigKeys.ViewType]: ViewType
  [AccountListConfigKeys.ColumnState]: ColumnState[]
}

export enum FilterPaneState {
  Closed = 'Closed',
  Open = 'Open',
}

export enum RowClickBehavior {
  Preview = 'Preview',
}

export enum QuickPreviewLocation {
  Right = 'Right',
}

export enum ViewType {
  Standard = 'Standard',
  Compact = 'Compact',
}
